import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class TxnTypeFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            txnTypeLists: [],
            txnTypeValue: props.default_all === true ? [{value: 'all', label: 'All'}] : {value: 'SALE', label: 'SALE'},
        };
    }
    componentDidMount(){
        this.getTxnType();
    }
    resetTxnTypeFilter() {
        this.setState({
            txnTypeValue: this.props.default_all === true ? [{value: "all", label: "All"}] : [{value: "SALE", label: "SALE"}],
        })
    }
    getTxnType(){
        var is_dcc_sale_leg1 = '';
        if(this.props.is_dcc_sale_leg1) {
            is_dcc_sale_leg1 = this.props.is_dcc_sale_leg1
        }
        axios.get(config.get('API_URL')+'/filters/get-txn-type/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                is_upi_leg1: this.props.is_upi_leg1,
                is_dcc_sale_leg1:is_dcc_sale_leg1
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((txn_type, index) => {
                    this.state.txnTypeLists.push({value: txn_type.txn_code, label: txn_type.txn_display_name})
                });
            }
//             this.setState({
//                 isTenderModeLoading: false
//             })
        });

    }

    changeTxnType(optionSelected){
        let value='';
        let txnArray = [];
        if (optionSelected.length < 1) {
            value = null;
            txnArray = ["all"];
        }
        else{
            optionSelected.map((mids, i) => {
                txnArray.push(mids.value)
                // var index = this.state.txnTypeLists.findIndex(obj => obj.value==mids.value);
                // this.state.txnTypeLists.move(index,0).join(',');
            });
        }
        if(txnArray.includes("DCC SALE leg1")===true && txnArray.includes("UPI Leg1")===true) {
            txnArray = txnArray[0];
            optionSelected = [{value: txnArray[0], label: txnArray[0]}];
        }
        if(txnArray.includes("DCC SALE leg1")===true) {
            txnArray = ['DCC SALE leg1'];
            optionSelected = [{value: "DCC SALE leg1", label: "DCC SALE leg1"}];
        }
        if(txnArray.includes("UPI Leg1")===true) {
            txnArray = ['UPI Leg1'];
            optionSelected = [{value: "UPI Leg1", label: "UPI Leg1"}];
        }
        this.props.onSelectTxnType(optionSelected,txnArray);
        this.setState({
            txnTypeValue:optionSelected,
        });
    }
    render() {
        return (
            <ReactMultiSelectCheckboxes name="txn_type"
                isMulti
                value={this.state.txnTypeValue}
                 styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeTxnType.bind(this)}
                options={this.state.txnTypeLists}
                placeholderButtonLabel="Select [Txn Type ]"
            />
        );

    }
}
export default TxnTypeFilter;